import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputEMailAnhangAttachementsRelation } from './InputEMailAnhangAttachementsRelation.entity';
import { InputTopicMarkRelation } from './InputTopicMarkRelation.entity';

export class InputEMailRelation<T extends EMode = EMode.entity> {
  /** Alias: attachements */
  attachements?: InputEMailAnhangAttachementsRelation<T>;
  /** Alias: topic */
  topic?: InputTopicMarkRelation<T>;

  __typename?: string;
}

const fields: FieldDefinitions<InputEMailRelation> = {
  attachements: {
    alias: 'attachements',
  },
  topic: {
    alias: 'topic',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputEMailRelationEntityDefinition: EntitiyDefinition<InputEMailRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputEMailRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
